import { BarSeries, Chart, ScaleType, Settings } from '@elastic/charts';
import { Grid, Tooltip } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import { clamp } from 'lodash';
import React from 'react';
import TypeBudget from '../../../constants/simulation/typeBudget';
import type PanelProps from '../../../interfaces/simulation/panelProps';
import { formatWithSpaces } from '../../../utils/simulation/panel';
import './EpargneBrute.css';

const EpargneNette = ({ data, tooltip }: PanelProps) => {
	let epargneNette = 0;
	let cumul = 0;
	let taux = 0;

	if (
		!data?.transfertCpta ||
		data?.typeBudget === TypeBudget.COMPTE_ADMINISTRATIF
	) {
		epargneNette =
			(data?.epargneBrute ?? 0) - (data?.remboursementCapitalDette ?? 0);
		cumul = epargneNette + (data?.recetteReelFonctionnement ?? 0);
		taux = clamp(cumul > 0 ? (epargneNette * 100) / cumul : 0, 0, 100);
	}

	const chartData = [
		{
			x: 'Epargne Nette N-2',
			y:
				(data?.exercicePrecedent2?.epargneBrute ?? 0) -
				(data?.exercicePrecedent2?.remboursementCapitalDette ?? 0) -
				(data?.exercicePrecedent2?.remboursementInteretDette ?? 0),
			g: 'Valeur',
		},
		{
			x: 'Epargne Nette N-1',
			y:
				(data?.exercicePrecedent?.epargneBrute ?? 0) -
				(data?.exercicePrecedent?.remboursementCapitalDette ?? 0) -
				(data?.exercicePrecedent?.remboursementInteretDette ?? 0),
			g: 'Valeur',
		},
		{ x: 'Epargne Nette', y: epargneNette, g: 'Valeur :' },
	];

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={10}>
					<Tooltip
						message={tooltip}
						trigger={
							<div className="bold indicateurTitle">
								{`Epargne nette ${data?.anneeExercice}`}
							</div>
						}
						type="information"
					/>

					<br />
					<br />
					{`${data?.typeBudget === TypeBudget.COMPTE_ADMINISTRATIF ? 'Réalisations' : 'Prévisions'} :`}
					<br />
					<span data-testid="epargneNette">{formatMontant(epargneNette)}</span>
					<br />
					<br />
					<span data-testid="tauxEpargneNette">{`Taux: ${taux?.toFixed(2)}%`}</span>
				</Grid.Column>
				<Grid.Column width={6} className="epargneChartContainer">
					<Chart>
						<Settings />
						<BarSeries
							color={['#737373', epargneNette >= 0 ? '#2193ac' : '#a61f43']}
							data={chartData}
							id="epargneNette"
							minBarHeight={10}
							splitSeriesAccessors={['g']}
							stackAccessors={['x']}
							tickFormat={formatWithSpaces}
							xAccessor="x"
							xScaleType={ScaleType.Linear}
							yAccessors={['y']}
							yScaleType={ScaleType.Linear}
						/>
					</Chart>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default EpargneNette;
